import React from 'react';
import {connect} from 'react-redux';
import ListWarehouse from "./components"
import {setMenuActive} from "../../Common/actions";
import {fetchListWarehouse} from "./actions";
import {getListWarehouse, getState} from "./selectors";
import SearchableComponent from "../../Common/components/SearchableComponent";

const mapStateToProps = (state, props) => ({
	listWarehouse: getListWarehouse(state, props.route.name),
	loading: getState(state, 'loading', false)
});
const mapDispatchToProps = (dispatch) => ({
	setMenuActive: (menu) => dispatch(setMenuActive(menu)),
	fetchListWarehouse: (filter) => dispatch(fetchListWarehouse(filter)),
});

class ListWarehouseContainer extends SearchableComponent {

	onSearch(filter) {
		this.pushFilter({
			...filter,
			i: parseInt(filter.i || 0, 0) + 1,
		});
	}

	onChangeFilter(filter) {
		filter.sort_by = 'name';
		filter.sort_direction = 'asc';
		filter.is_custom_warehouse = true;

		this.props.fetchListWarehouse(filter);
	}

	getCurrentFilter() {
		return {
			page: 1,
			sort_by: 'name',
			sort_direction: 'asc',
			...this.getFilterFromLocation(this.props.location),
		};
		;
	}

	render() {
		return <ListWarehouse
			{...this.props}
			filter={this.getCurrentFilter()}
			onSearch={this.onSearch.bind(this)}/>
	}
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ListWarehouseContainer);
